import { useMutation } from '@tanstack/react-query';
import { useCallback, useEffect } from 'react';
import { ai } from '@sekoia/shared/utils/telemetryService';
import { CompassClient } from 'requests/compassClient';

export const useAssignUserAsARelative = (compassUrl: string, key: string) => {
  useEffect(() => {
    CompassClient.createInstance(compassUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const assignUserToRelativeInvitation = useCallback(async () => {
    const compassClient = CompassClient.Instance;
    const response = await compassClient.post(`api/profiles/relatives/assigninvitation`, { key });

    return response.status >= 200 && response.status < 300;
  }, [key]);

  return useMutation({
    mutationFn: assignUserToRelativeInvitation,
    onError: (e) => {
      ai.trackException({
        exception: e,
      });
    },
  });
};
